<template>
  <div v-if="visible" class="delete-modal-backdrop" @click.self="$emit('close')">
    <div class="delete-modal">
      <div class="delete-modal__hero">
        <div>
          <span class="delete-modal__eyebrow">Cancel subscription</span>
          <h3>Cancel this subscription?</h3>
          <p>
            {{
              organizationName
                ? `This will cancel the subscription for ${organizationName}.`
                : 'This will cancel the selected subscription.'
            }}
          </p>
        </div>

        <button
          type="button"
          class="delete-modal__close"
          aria-label="Close delete modal"
          @click="$emit('close')"
        >
          <i class="fas fa-times" aria-hidden="true"></i>
        </button>
      </div>

      <div class="delete-modal__body">
        <div class="delete-summary-card">
          <span class="delete-summary-card__label">Organization</span>
          <strong>{{ organizationName || 'Not available' }}</strong>
        </div>

        <div class="delete-summary-grid">
          <div class="delete-summary-card">
            <span class="delete-summary-card__label">Status</span>
            <strong>{{ subscription?.status || 'Not available' }}</strong>
          </div>
        </div>
      </div>

      <div class="delete-modal__actions">
        <button
          type="button"
          class="modal-button modal-button--ghost"
          :disabled="loading"
          @click="$emit('close')"
        >
          Cancel
        </button>
        <button
          type="button"
          class="modal-button modal-button--danger"
          :disabled="loading"
          @click="$emit('confirm')"
        >
          {{ loading ? 'Cancelling...' : 'Cancel Subscription' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeleteSubscriptionModal',

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    subscription: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    organizationName() {
      return this.subscription?.organizationName || this.subscription?.organization_name || '';
    },
  },
};
</script>

<style scoped>
.delete-modal-backdrop {
  position: fixed;
  inset: 0;
  display: grid;
  place-items: center;
  padding: 1.5rem;
  background: rgba(10, 28, 16, 0.42);
  backdrop-filter: blur(6px);
  z-index: 1200;
}

.delete-modal {
  width: min(100%, 34rem);
  border-radius: 28px;
  border: 1px solid rgba(130, 39, 39, 0.08);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(251, 245, 245, 0.98));
  box-shadow: 0 32px 80px rgba(34, 14, 14, 0.18);
  overflow: hidden;
}

.delete-modal__hero {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.5rem 1.5rem 1rem;
}

.delete-modal__eyebrow {
  display: inline-flex;
  margin-bottom: 0.45rem;
  color: #bb4e4e;
  font-size: 0.76rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.delete-modal__hero h3 {
  margin: 0 0 0.45rem;
  color: #3a1717;
}

.delete-modal__hero p {
  margin: 0;
  color: #765959;
  line-height: 1.6;
}

.delete-modal__close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.4rem;
  height: 2.4rem;
  border: 0;
  border-radius: 999px;
  background: #fbefed;
  color: #bb4e4e;
}

.delete-modal__body {
  padding: 0 1.5rem 1rem;
}

.delete-summary-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.85rem;
  margin-top: 0.85rem;
}

.delete-summary-card {
  padding: 1rem 1.05rem;
  border: 1px solid rgba(130, 39, 39, 0.08);
  border-radius: 18px;
  background: rgba(252, 247, 247, 0.98);
}

.delete-summary-card__label {
  display: block;
  margin-bottom: 0.35rem;
  color: #8a6d6d;
  font-size: 0.78rem;
}

.delete-summary-card strong {
  color: #3a1717;
}

.delete-modal__actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1rem 1.5rem 1.5rem;
}

.modal-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 9rem;
  padding: 0.85rem 1.1rem;
  border-radius: 14px;
  font-weight: 700;
  border: 0;
}

.modal-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.modal-button--ghost {
  background: #f4eded;
  color: #5e4444;
}

.modal-button--danger {
  background: linear-gradient(135deg, #cf5c5c, #a53a3a);
  color: #ffffff;
}

@media (max-width: 767px) {
  .delete-modal {
    width: 100%;
  }

  .delete-summary-grid {
    grid-template-columns: 1fr;
  }

  .delete-modal__actions {
    flex-direction: column-reverse;
  }

  .modal-button {
    width: 100%;
  }
}
</style>
